import { render, staticRenderFns } from "./stock-transaction-modal.vue?vue&type=template&id=01980ac0&scoped=true&"
import script from "./stock-transaction-modal.vue?vue&type=script&lang=js&"
export * from "./stock-transaction-modal.vue?vue&type=script&lang=js&"
import style0 from "./stock-transaction-modal.vue?vue&type=style&index=0&id=01980ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01980ac0",
  null
  
)

export default component.exports